module.exports = __webpack_public_path__ + "cad_icon.svg?a71776d8749ca4693ff576ac0b5e9234";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/cad_icon.svg
// module id = 1133
// module chunks = 2